import React, { useState, useRef, useEffect } from "react";

export default function CustomDatalistModal({
  value,
  onChange,
  options,
  placeholder = "",
  name,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(value || "");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const inputRef = useRef(null);
  const modalRef = useRef(null);

  // Update filtered options when searchTerm or options change
  useEffect(() => {
    setFilteredOptions(
      options.filter((option) => option.text.toLowerCase().includes(searchTerm.toLowerCase()))
    );
  }, [searchTerm, options]);

  // Handle clicks outside the modal
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Focus input when modal opens
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    onChange(e); // Propagate change to parent
  };

  const handleSelectOption = (selectedValue) => {
    setSearchTerm(selectedValue);
    setIsOpen(false);
    // Create a synthetic event to match your existing handleCustomerChange
    const syntheticEvent = {
      target: {
        name,
        value: selectedValue,
      },
    };
    onChange(syntheticEvent);
  };

  return (
    <div className="custom-datalist form-row" ref={modalRef}>
      <label className="form-label">Customer Name</label>
      <input
        ref={inputRef}
        type="text"
        value={searchTerm}
        onChange={handleInputChange}
        onFocus={() => setIsOpen(true)}
        placeholder={placeholder}
        className="form-input custom-datalist-input"
      />
      {isOpen && filteredOptions.length > 0 && (
        <div className="custom-datalist-modal">
          {filteredOptions.map((option) => (
            <div
              key={option.key || option.text}
              className="custom-datalist-option"
              onClick={() => handleSelectOption(option.text)}
            >
              {option.text}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
